import { render, staticRenderFns } from "./AdminEditWorkspacePage.vue?vue&type=template&id=f984a878"
import script from "./AdminEditWorkspacePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEditWorkspacePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports